export function createModalComponent(componentName: string, componentProps?: any) {
  const modalElement = document.createElement('mama-modal');
  modalElement.modalClass = componentName.replace('mama-', '');

  const component = document.createElement(componentName);
  Object.assign(component, componentProps || {});
  modalElement.append(component);

  document.body.appendChild(modalElement);
}
